import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BackPanelComponent } from './back-panel/back-panel.component';
import { FilterChipComponent } from './filter-chip/filter-chip.component';
import { FilterBarComponent } from './filter-bar/filter-bar.component';
import {SharedModule} from 'shared/shared.module';



@NgModule({
    declarations: [
        BackPanelComponent,
        FilterChipComponent,
        FilterBarComponent
    ],
    exports: [
        BackPanelComponent,
        FilterChipComponent,
        FilterBarComponent
    ],
    imports: [
        CommonModule,
        SharedModule
    ]
})
export class UiModule { }
